module.exports = __webpack_public_path__ + "static/tat-6-0000d117ab673a7896acebfa67a34a36.jpg";